module.exports = __webpack_public_path__ + "img/0Q3B3793_L_Foamcore_MockedUp.3ed61144.jpg";